<template>
  <div
    class="navbar-header"
    :class="$store.state.currentUser.role.code === 'sp' ? 'd-block' : 'd-xl-block d-none'"
    style="z-index: 1; "
  >
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo ml-2 pl-1">
            <b-img
              class="h-100 w-100"
              :src="appLogoImage"
              alt="logo"
            />
          </span>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style>
  .brand-logo img {
    max-height: 30px;
    max-width: 100% !important;
  }
</style>
